var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { colCls } from "./Col.less";
function Col(_ref) {
  var _ref$tagName = _ref.tagName, Tag = _ref$tagName === void 0 ? "div" : _ref$tagName, children = _ref.children, className = _ref.className, _ref$xs = _ref.xs, xs = _ref$xs === void 0 ? null : _ref$xs, _ref$sm = _ref.sm, sm = _ref$sm === void 0 ? null : _ref$sm, _ref$md = _ref.md, md = _ref$md === void 0 ? null : _ref$md, _ref$lg = _ref.lg, lg = _ref$lg === void 0 ? null : _ref$lg, _ref$xl = _ref.xl, xl = _ref$xl === void 0 ? null : _ref$xl;
  var settings = {
    xs,
    sm,
    md,
    lg,
    xl
  };
  var colClassNames = Object.keys(settings).map(function(key) {
    return settings[key] ? "".concat(colCls, "-").concat(key.toLowerCase(), "-").concat(settings[key]) : null;
  }).filter(function(i) {
    return i;
  }).join(" ");
  return /* @__PURE__ */ React.createElement(Tag, {
    className: classNames(colCls, colClassNames, className)
  }, children);
}
__name(Col, "Col");
export {
  Col
};
